import React from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { urlFor } from '../../client';
import {
	BoldText,
	MotionStyledFlexContainer,
	ParagraphText,
	WorkContent,
	WorkHoverDiv,
	WorkImg,
	WorkItem,
} from '../../styles';

const WorkCard = ({ work }) => {
	return (
		<WorkItem>
			<WorkImg>
				<img src={urlFor(work.imgUrl)} alt={work.name} />

				<WorkHoverDiv
					whileHover={{ opacity: [0, 1] }}
					transition={{
						duration: 0.25,
						ease: 'easeInOut',
						staggerChildren: 0.5,
					}}
				>
					<a href={work.projectLink} target='_blank' rel='noreferrer'>
						<MotionStyledFlexContainer
							whileInView={{ scale: [0, 1] }}
							whileHover={{ scale: [1, 0.9] }}
							transition={{ duration: 0.25 }}
						>
							<AiFillEye />
						</MotionStyledFlexContainer>
					</a>
					<a href={work.codeLink} target='_blank' rel='noreferrer'>
						<MotionStyledFlexContainer
							whileInView={{ scale: [0, 1] }}
							whileHover={{ scale: [1, 0.9] }}
							transition={{ duration: 0.25 }}
						>
							<AiFillGithub />
						</MotionStyledFlexContainer>
					</a>
				</WorkHoverDiv>
			</WorkImg>

			<WorkContent>
				<BoldText>{work.title}</BoldText>
				<ParagraphText style={{ marginTop: 10 }}>{work.description}</ParagraphText>
			</WorkContent>
		</WorkItem>
	);
};

export default WorkCard;
